import { render, staticRenderFns } from "./ProductShowButton.vue?vue&type=template&id=6bfa9c72&scoped=true&"
import script from "./ProductShowButton.vue?vue&type=script&lang=ts&"
export * from "./ProductShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductShowButton.vue?vue&type=style&index=0&id=6bfa9c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa9c72",
  null
  
)

export default component.exports